export type ChatEventType =
  | 'client_message'
  | 'assistant_message_human'
  | 'assistant_message_ai'
  | 'system_handoff_event'
  | 'conversation_note';

export type SpeakerType = 'human_fa' | 'ai_agent' | 'client' | null;
export type AvatarType =
  | 'human_initials'
  | 'aifa_icon'
  | 'client_initials'
  | null;
export type EventVisibility = 'internal' | 'client_visible';
export type EventStatus = 'pending' | 'sent' | 'failed';
export type ChatFilter =
  | 'all'
  | 'client'
  | 'fa'
  | 'aifa'
  | 'notes'
  | 'handoffs';
export type ViewMode = 'conversation' | 'full';

export interface ChatEvent {
  id: string;
  conversationId?: string;
  eventType: ChatEventType;
  createdAt: string;
  content: string;
  speakerType: SpeakerType;
  speakerId?: string;
  speakerDisplayName?: string;
  speakerRoleLabel?: string;
  avatarType: AvatarType;
  intercomNoteId?: string;
  handoffReason?: string;
  visibility: EventVisibility;
  status: EventStatus;
}

export interface ChatFilterChip {
  id: ChatFilter;
  label: string;
}

export const CHAT_FILTER_CHIPS: ChatFilterChip[] = [
  { id: 'all', label: 'All' },
  { id: 'client', label: 'Client' },
  { id: 'fa', label: 'Financial Assistants' },
  { id: 'aifa', label: 'AIFA' },
  { id: 'notes', label: 'Notes' },
  { id: 'handoffs', label: 'Handoffs' },
];

export interface ViewModeOption {
  id: ViewMode;
  label: string;
}

export const VIEW_MODE_OPTIONS: ViewModeOption[] = [
  { id: 'conversation', label: 'Conversation only' },
  { id: 'full', label: 'Full view' },
];

/**
 * A ChatEvent decorated with typewriter rendering state.
 * For non-typewriter roles, renderedContent === content and typingComplete === true immediately.
 */
export interface RenderedChatEvent extends ChatEvent {
  renderedContent: string;
  typingComplete: boolean;
}

/** Opaque key identifying a specific demo step, used as a stale-response guard. */
export type StepKey = string;
